import { render, staticRenderFns } from "./PolicyFormInfo.vue?vue&type=template&id=0ab16e4e&scoped=true&"
import script from "./PolicyFormInfo.vue?vue&type=script&lang=ts&"
export * from "./PolicyFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyFormInfo.vue?vue&type=style&index=0&id=0ab16e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab16e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
